import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import Contracts from '../../../../api/api-contracts';
import { Listings } from '../../../../api/api-listings';
import { CateringPage } from '../../catering/CateringPage';
import { PageSpinner } from '../../shared-components/decorators/spinner';
import { useLoading } from '../../shared-components/utils/hooks/use-loading';

const CateringPageContainerCmp = ({
  routeParams = {},
  accessToken = '',
  profile = {}
}) => {
  const [booking, setBooking] = useState(null);
  const [listing, setListing] = useState(null);
  const [fetchError, setFetchError] = useState(null);

  const { asyncFn: fetchBooking, isLoading: bookingLoading } = useLoading(
    async () => {
      return new Promise((resolve, reject) => {
        Contracts.readContractsSnapshot(
          routeParams.bookingId,
          accessToken,
          (response) => {
            if (
              400 === response.statusCode ||
              (!response.contracts?.length && !response.pending?.length)
            ) {
              reject(response);
            }

            let spaceRentalContract = (response.contracts || []).find(
              (contract) => contract.type === 'SPACE_RENTAL'
            );
            if (!spaceRentalContract) {
              spaceRentalContract = (response.pending || []).find(
                (contract) => contract.type === 'SPACE_RENTAL'
              );
            }
            const booking = spaceRentalContract?.meta?.booking;
            if (!booking) {
              reject('No booking found in contract');
            }

            resolve(booking);
          }
        );
      });
    }
  );

  const { asyncFn: fetchListing, isLoading: listingLoading } = useLoading(
    async (listingId) => {
      return new Promise((resolve, reject) => {
        Listings.read(listingId, (response) => {
          if (400 === response.statusCode || response.error) {
            reject(response);
          }
          resolve(response);
        });
      });
    }
  );

  useEffect(() => {
    if (!routeParams?.bookingId || !accessToken) {
      return;
    }

    (async () => {
      try {
        const booking = await fetchBooking();
        const listing = await fetchListing(booking?.listing_id);
        setBooking(booking);
        setListing(listing);
      } catch (e) {
        setFetchError(e?.message || e);
      }
    })();
  }, [routeParams?.bookingId]);

  const analyticSent = useRef(false);
  useEffect(() => {
    if (!profile.hasFetched || !booking || analyticSent.current) {
      return;
    }
    analytics.track('catering_page_viewed', {
      booking_id: booking?._id,
      sso_id: profile?.data?.SSOid,
      activity_tag: booking?.tags?.activity
    });
    analyticSent.current = true;
  }, [booking, profile]);

  if (bookingLoading || listingLoading) {
    return <PageSpinner additionalStyle="gray" />;
  }

  if (fetchError) {
    window.location.href = `/inbox/${routeParams.bookingId}`;
    return;
  }

  return <CateringPage booking={booking} profile={profile} listing={listing} />;
};

export const CateringPageContainer = connect(({ profile }) => ({ profile }))(
  CateringPageContainerCmp
);
